import { createSlice } from '@reduxjs/toolkit';
import { fetchBenchmarks } from '../actions/benchmarksAction';

const benchmarksSlice = createSlice({
  name: 'benchmarks',
  initialState: {
    data: [],
    pagination: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBenchmarks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBenchmarks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchBenchmarks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Error fetching benchmarks';
      });
  },
});

export default benchmarksSlice.reducer; 